import { environment } from 'environments';
import { ChargeTypes } from '../../../../../../../../src/app/types/charge-types-enum.ts';
import { PICKUP_IDS_ARRAY, HYBRID_PICKUP_IDS_ARRAY } from './prescribe.model.ts';

(() => {
  const INVALID_PRESCRIPTION_MESSAGE = 'Please verify all prescription information';

  class PrescribeController {
    constructor(
      $rootScope,
      $interval,
      $scope,
      $timeout,
      $log,
      $window,
      toastr,
      Auth,
      ngDialog,
      Orders,
      Pharmacy,
      Notifications,
      Utils,
      Dosespot,
      Constants,
      MedicationService,
      localStorageService,
      VideoService,
      Tracking,
      Users,
      Services,
      ENV,
    ) {
      Object.assign(this, {
        Date,
        $rootScope,
        $scope,
        $timeout,
        $log,
        $window,
        $interval,
        toastr,
        ngDialog,
        Orders,
        Pharmacy,
        Notifications,
        Utils,
        Dosespot,
        Constants,
        MedicationService,
        localStorageService,
        VideoService,
        Tracking,
        Users,
        Services,
        ENV,
        currentUser: Auth.profile,
        polls: {},
        pharmacyTaskId: null,
        pharmacyTaskPending: false,
        areAllMedicationsSent: true,
        slv_visit_phone_call: 0,
        no_med_prescribed: false,
        medications: [],
        BOD_162_feature_flag_env: ['localhost'].includes(environment.constants.ENV),

        BOD_2442: ['localhost', 'dev', 'qa', 'staging', 'production'].includes(environment.constants.ENV),
        BOD_2433: ['localhost', 'dev', 'qa', 'staging', 'production'].includes(environment.constants.ENV),
        BODACDC_3909: FEATURE_BODACDC_3909,
        previous_pharmacy_option_id: null,
        pharmacyOptions: [],
        currentMedications: [],
      });

      $scope.$on('$destroy', () => {
        console.log('prescribe tab > $destroy');

        // this.resetAllPollingPrescriptionStatus();

        // To stop the dosespot status polling
        // If controller has been destroyed

        for (var key in this.polls) {
          if (this.polls.hasOwnProperty(key)) {
            if (this.polls[key]) {
              clearInterval(this.polls[key]);
              this.polls[key] = null;
            }
          }
        }
      });
      $scope.$on('_actuallyLogout', () => {
        console.log('prescribe tab > _actuallyLogout');
        // To stop the dosespot status polling
        // If logout or session expired

        for (var key in this.polls) {
          if (this.polls.hasOwnProperty(key)) {
            if (this.polls[key]) {
              clearInterval(this.polls[key]);
              this.polls[key] = null;
            }
          }
        }
      });
      // $scope.$on('tab:selected:prescribe', this.init.bind(this));

      $scope.$on('tab:selected:prescribe', (event, refreshOrder = false) => {
        this.initializePrescribeTab(false, refreshOrder);
        this.setStylingPharmacyOptionsAndSearchBoxes();

        if (this.visit.phone_call.phone_call_completed == null) {
          this.callCompleted = 'Verify Patient was called';
          this.showCallBox = false;
        } else {
          this.callCompleted = 'Patient was called';
          this.showCallBox = true;
        }

        if (this.visit.phone_call.is_phone_call_required != 1) {
        }
      });
      $scope.$on('slv-task-approval:success', () => {
        console.log('prescribe tab > slv-task-approval:success');
        this.slv_task_approved = true;
      });
      $scope.$on('slv-task-approval:fail', () => {
        console.log('prescribe tab > slv-task-approval:fail');
        this.slv_task_approved = false;
      });
    }

    $onInit() {
      if (this.visit.flags.slv && this.visit.phone_call.phone_call_completed) this.slv_visit_phone_call = 1;

      if (this.visit.flags.slv) this.slv_task_approved = this.slvCheckedOk();

      if (this.visitIsComplete() && !this.hasMedications()) this.no_med_prescribed = true;

      // CMS CONTENT > PIMS VISIT PARAMETERS

      this.pimsParameters = this.localStorageService.get('pimsParameters');

      // validate_no_medication_prescribed_checkbox

      this.validate_no_medication_prescribed_checkbox = false;

      if (
        this.pimsParameters &&
        this.pimsParameters.pimsVisitParameters &&
        this.pimsParameters.pimsVisitParameters.validate_no_medication_prescribed_checkbox &&
        this.pimsParameters.pimsVisitParameters.validate_no_medication_prescribed_checkbox.includes(
          this.visit.service.code,
        )
      ) {
        this.validate_no_medication_prescribed_checkbox = true;
      }

      // skip_refill_api_calls

      this.skip_refill_api_calls = false;

      if (
        this.pimsParameters &&
        this.pimsParameters.pimsVisitParameters &&
        this.pimsParameters.pimsVisitParameters.skip_refill_api_calls
      )
        this.skip_refill_api_calls = true;

      // allow_create_new_pims_meds

      this.allow_create_new_pims_meds = false;

      if (
        this.pimsParameters &&
        this.pimsParameters.pimsVisitParameters &&
        this.pimsParameters.pimsVisitParameters.allow_create_new_pims_meds &&
        this.pimsParameters.pimsVisitParameters.allow_create_new_pims_meds.length
      ) {
        this.pimsParameters.pimsVisitParameters.allow_create_new_pims_meds.forEach(service => {
          if (this.visit.service.code == service) this.allow_create_new_pims_meds = true;
        });
      }

      // hide_add_prescription_button

      this.hide_add_prescription_button = false;

      if (
        this.pimsParameters &&
        this.pimsParameters.pimsVisitParameters &&
        this.pimsParameters.pimsVisitParameters.hide_add_prescription_button &&
        this.pimsParameters.pimsVisitParameters.hide_add_prescription_button.length
      ) {
        this.pimsParameters.pimsVisitParameters.hide_add_prescription_button.forEach(service => {
          if (this.visit.service.code == service) this.hide_add_prescription_button = true;
        });
      }

      // allow_skip_prescription_whole_service

      this.allow_skip_prescription_whole_service = false;

      if (
        this.pimsParameters &&
        this.pimsParameters.pimsVisitParameters &&
        this.pimsParameters.pimsVisitParameters.allow_skip_prescription_whole_service
      ) {
        this.pimsParameters.pimsVisitParameters.allow_skip_prescription_whole_service.forEach(service => {
          if (this.visit.service.code == service) {
            this.allow_skip_prescription_whole_service = true;
          }
        });
      }

      // send_automatic_visit_note_after_visit_completion

      this.visit_note_after_visit_completion = '';

      if (
        this.pimsParameters &&
        this.pimsParameters.pimsVisitParameters &&
        this.pimsParameters.pimsVisitParameters.send_automatic_visit_note_after_visit_completion &&
        this.pimsParameters.pimsVisitParameters.send_automatic_visit_note_after_visit_completion[
          this.visit.service.code
        ] &&
        this.pimsParameters.pimsVisitParameters.send_automatic_visit_note_after_visit_completion[
          this.visit.service.code
        ].visit_note
      ) {
        this.visit_note_after_visit_completion =
          this.pimsParameters.pimsVisitParameters.send_automatic_visit_note_after_visit_completion[
            this.visit.service.code
          ].visit_note;
      }
    }

    // $onInit() {

    init() {
      this.initializePrescribeTab(false, false);
      this.setStylingPharmacyOptionsAndSearchBoxes();
    }

    cachePrescriptions() {
      var visitMedications = { visitId: this.visit.id };

      if (this.medications && Array.isArray(this.medications) && this.medications.length) {
        visitMedications.medications = this.medications;
      } else {
        visitMedications.medications = [];
      }

      this.localStorageService.set('visitMedications', visitMedications);
    }

    setFocusEventsPrescriptionEditor() {
      var this2 = this;

      this.$timeout(() => {
        // $(".prescription-editor-class").focus(function() {
        //   console.log("prescription-editor: focus in");
        // });

        $('.prescription-editor-class').focusout(function () {
          console.log('prescription-editor: focus out');
          this2.cachePrescriptions();
        });

        // }, 2000);
      });
    }

    setStylingPharmacyOptionsAndSearchBoxes() {
      var this2 = this;

      // SET UI BEHAVIOUR FOR MEDICATION SEARCH BOXES AND PHARMACY OPTIONS DROPDOWN

      $('#addPrescriptionInputId').focus(function () {
        var headerWidth = $('#prescribe-tab-header').width();
        var titleWidth = $('#prescribe-tab-title').width();
        var boxesWidth = headerWidth - titleWidth;
        var width = boxesWidth.toString() + 'px';

        $('#change-prescription-wrapper').css({ display: 'none' });
        $('#pharmacy-options-wrapper').css({ display: 'none' });

        if (headerWidth > 584) {
          $('#add-prescription-wrapper').css({ 'margin-left': '0px', width: '390px' });
        } else {
          $('#add-prescription-wrapper').css({ 'margin-left': '0px', width: width });
        }
      });

      $('#addPrescriptionInputId').focusout(function () {
        $('#add-prescription-wrapper').css({ width: '132px', display: 'inline-block', 'margin-left': '10px' });
        if (this2.numMedicationsNotSent(this2.medications)) {
          $('#change-prescription-wrapper').css({ width: '100px', display: 'inline-block', 'margin-left': '10px' });
        }
        if (this2.showPharmacyOptionsDropdown()) {
          $('#pharmacy-options-wrapper').css({ width: '170px', display: 'inline-block' });
        }
      });

      $('#changePrescriptionInputId').focus(function () {
        var headerWidth = $('#prescribe-tab-header').width();
        var titleWidth = $('#prescribe-tab-title').width();
        var boxesWidth = headerWidth - titleWidth;
        var width = boxesWidth.toString() + 'px';

        $('#add-prescription-wrapper').css({ display: 'none' });
        $('#pharmacy-options-wrapper').css({ display: 'none' });

        if (headerWidth > 584) {
          $('#change-prescription-wrapper').css({ 'margin-left': '0px', width: '390px' });
        } else {
          $('#change-prescription-wrapper').css({ 'margin-left': '0px', width: width });
        }
      });

      $('#changePrescriptionInputId').focusout(function () {
        $('#add-prescription-wrapper').css({ width: '132px', display: 'inline-block', 'margin-left': '10px' });
        if (this2.numMedicationsNotSent(this2.medications)) {
          $('#change-prescription-wrapper').css({ width: '100px', display: 'inline-block', 'margin-left': '10px' });
        }
        if (this2.showPharmacyOptionsDropdown()) {
          $('#pharmacy-options-wrapper').css({ width: '170px', display: 'inline-block' });
        }
      });
    }

    changePharmacyOption() {
      const isMedSaved = this.isMedicationsSaved();
      this.pharmacyOptionSelected = this.pharmacyOptionsSelected[0].id;
      if (this.BODACDC_3909) {
        this.pharmacyOption = this.pharmacyOptions.find(x => x.id === this.pharmacyOptionSelected);
      }
      this.previous_pharmacy_option_id = this.previous_pharmacy_option_id
        ? this.previous_pharmacy_option_id
        : this.visit.order_lines[0].pharmacy_option.id.toString();
      let pharmacySearchRequest = null;
      if (this.BOD_2433) {
        if ([...PICKUP_IDS_ARRAY, ...HYBRID_PICKUP_IDS_ARRAY].includes(this.pharmacyOptionsSelected[0].code)) {
          pharmacySearchRequest = this.Pharmacy.openSearchDialog({}, false);
        } else {
          pharmacySearchRequest = this.Pharmacy.fetch(4900).then(data => data.data);
        }
      } else {
        if (
          this.pharmacyOptionSelected.toString() !== this.previous_pharmacy_option_id ||
          this.pharmacyOptionSelected.toString() === '1'
        ) {
          if (this.pharmacyOptionSelected.toString() === '1') {
            pharmacySearchRequest = this.Pharmacy.openSearchDialog({}, false);
          } else if (['2', '17'].includes(this.pharmacyOptionSelected)) {
            pharmacySearchRequest = this.Pharmacy.fetch(4900).then(data => data.data);
          }
        }
      }

      if (pharmacySearchRequest) {
        pharmacySearchRequest.then(pharmacy => {
          // If the user closed without adding a pharmacy
          if (!pharmacy) {
            this.pharmacyOptionSelected = this.previous_pharmacy_option_id;
            this.pharmacyOptions.forEach(option => {
              option.selected = false;
            });
            this.pharmacyOptions.find(option => option.id == this.previous_pharmacy_option_id).selected = true;
            return;
          }
          let payload = {};
          if (this.BOD_2433) {
            if ([...PICKUP_IDS_ARRAY, ...HYBRID_PICKUP_IDS_ARRAY].includes(this.pharmacyOptionsSelected[0].code)) {
              payload.pharmacy_id = pharmacy.id;
            }
            payload.pharmacy_option_id = parseInt(this.pharmacyOptionSelected);
          } else {
            payload = isMedSaved
              ? { pharmacy_option_id: parseInt(this.pharmacyOptionSelected) }
              : { pharmacy_id: pharmacy.id };
          }

          this.Orders.updatePharmacyOption(this.Orders.current.id, payload)
            .then(data => {
              this.toastr.success('Pharmacy Updated successfully.');
              this.previous_pharmacy_option_id = this.pharmacyOptionSelected.toString();
              // PIMS - Need to refresh the page to add a new prescription
              // https://app.asana.com/0/333364685358613/1114531332208659
              this.medications.forEach(medication => {
                medication.pharmacy = pharmacy;
              });

              if (isMedSaved || _.includes(this.currentUser.roles, this.Users.ROLES.DOCTOR.NAME)) {
                this.saveMedicationsToOrder();
                this.toastr.success('Please double check the dosage. It may have changed.');
              }
            })
            .catch(err => {
              const summary = err.data.message.summary ? err.data.message.summary : JSON.stringify(err.data);
              this.toastr.error("Error updating visit's pharmacy option: " + summary);
              this.pharmacyOptionSelected = this.previous_pharmacy_option_id;
              this.pharmacyOptions.forEach(option => {
                option.selected = false;
              });
              this.pharmacyOptions.find(option => option.id == this.previous_pharmacy_option_id).selected = true;
            });
        });
      }
    }

    initializePrescribeTab(afterChangePharmacyOption, refreshOrder) {
      var this2 = this;

      // We get the pharmacy options for the current service
      this.Services.getPharmacyOptionsByCategory(this.Orders.current.service.id)
        .then(({ data }) => {
          this2.pharmacyOptions = [];

          if (data.pharmacy_options && data.pharmacy_options.length) {
            data.pharmacy_options.forEach(pharmacy_option => {
              pharmacy_option.id = pharmacy_option.id.toString();
              this2.pharmacyOptions.push({
                ...pharmacy_option,
                label: pharmacy_option.id === '1' ? 'Select Pharmacy for Pick-up' : pharmacy_option.name,
                selected: false,
              });
            });
          }

          if (afterChangePharmacyOption || refreshOrder) {
            // We get the latest data for current order
            this2.Orders.getOne(this2.Orders.current.id)
              .then(({ data }) => {
                Object.assign(this2.Orders.current, data);

                this2.visit = this2.Orders.current;
                this2.orderline = this2.visit.order_lines[0];

                this2.setupData(afterChangePharmacyOption);
              })
              .catch(err => {
                this2.toastr.error('Error getting visit data: ' + err.status + ' - ' + err.message);
              });
          } else {
            // HERE WE AVOID SECOND API CALL TO GET ADMIN/ORDER
            // AFTER DOCTOR JUST OPENED A NEW VISIT

            this2.visit = this2.Orders.current;
            this2.orderline = this2.visit.order_lines[0];

            this2.setupData(afterChangePharmacyOption);
          }
        })
        .catch(err => {
          console.log(err);
        });
    }

    setupData(afterChangePharmacyOption) {
      var pharmacy_option = null;

      if (this.visit.order_lines[0].pharmacy_option && this.pharmacyOptions.length) {
        pharmacy_option = this.visit.order_lines[0].pharmacy_option;
        this.pharmacyOptions.find(option => option.id == pharmacy_option.id).selected = true;
        this.pharmacyOptionSelected = pharmacy_option.id.toString();

        this.pharmacyOptions.forEach(pharmacyOption => {
          if (this.pharmacyOptionSelected === pharmacyOption.id) {
            this.pharmacyOption = pharmacyOption;
          }
        });
      }

      var pharmacyTask = this.Orders.getTaskByType(this.Constants.VisitTasks.Delivery, this.visit, 0);

      if (!pharmacyTask) {
        this.pharmacyTaskPending = false;
      } else {
        this.pharmacyTaskId = pharmacyTask.id;
        if (pharmacyTask.status === this.Constants.VisitStatuses.PendingReview) this.pharmacyTaskPending = true;
        else this.pharmacyTaskPending = false;
      }

      this.saveMedicationsDisabled =
        this.serviceHasLabs() &&
        this.visit.admin_status != this.Constants.AdminStatuses.LabOrderSent.NumericValue &&
        this.visit.admin_status != this.Constants.AdminStatuses.LabResultsReceived.NumericValue &&
        this.visit.admin_status != this.Constants.AdminStatuses.MedicinePrescribed.NumericValue &&
        this.visit.admin_status != this.Constants.AdminStatuses.RemoteRxCreated.NumericValue &&
        this.visit.admin_status != this.Constants.AdminStatuses.RemoteRxSent.NumericValue &&
        this.visit.admin_status != this.Constants.AdminStatuses.Complete.NumericValue;

      // ****** NEW LOGIC TO SHOW THE PRESCRIPTIONS ***** //
      //
      // AFTER DISCUSSING WITH GREG, WE WILL SHOW:
      //
      // 1) SAVED PRESCRIPTIONS IF:
      //    - VISIT IS ALREADY COMPLETED
      //    - VISIT IS NOT COMPLETED, THERE ARE SAVED PRESCRIPTIONS AND DOCTOR DID NOT CHANGE PHARMACY OPTION
      //
      // 2) DEFAULT PRESCRIPTIONS IF:
      //    - VISIT IS NOT COMPLETED, THERE ARE NO SAVED PRESCRIPTIONS
      //    - VISIT IS NOT COMPLETED, THERE ARE SAVED PRESCRIPTIONS AND DOCTOR CHANGED PHARMACY OPTION

      // NOW WE CHECK THE CACHE DATA FIRST
      var visitMedications = this.localStorageService.get('visitMedications');

      if (
        !afterChangePharmacyOption &&
        visitMedications &&
        visitMedications.visitId &&
        visitMedications.visitId === this.visit.id &&
        visitMedications.medications.length
      ) {
        this.medications = visitMedications.medications;
      } else {
        if (afterChangePharmacyOption && !this.anyMedicationHasBeenSent()) {
          this.medications = [];
        } else {
          // Try to pull in medications that have already been attached to the orderline
          this.medications = Array.isArray(this.visit.prescriptions) ? angular.copy(this.visit.prescriptions) : [];
        }
      }

      // ****** NEW LOGIC TO SHOW THE PRESCRIPTIONS ***** //

      this.markAllMedicationsAsSaved();

      // var lastDefaultPrescription;

      // If the visit is not complete and no medications have been attached and a default medication is available
      // Then we automatically add the default medication
      if (
        !this.visitIsComplete() &&
        !this.medications.length &&
        this.visit.default_prescriptions &&
        this.visit.default_prescriptions.length > 0
      ) {
        this.formatDefaultPrescription();
      }

      // AFTER DISCUSSING WITH GREG, WE DECIDED TO NOT ADD ANY ROWS FOR HYBRID AUTOMATICALLY:
      /*
      // If the Order is NOT complete, became Hybrid and has only one row
      // We clone the last default prescription and we add it as second row but without the pharmacy object
      // It means Doctor still needs to selects the pharmacy
      if (afterChangePharmacyOption && lastDefaultPrescription && pharmacy_option && pharmacy_option.fulfilment_type === 3 && this.medications.length === 1) {
        if (lastDefaultPrescription.pharmacy) {
          delete lastDefaultPrescription["pharmacy"];
        }
        this.medications.push(lastDefaultPrescription);
      }

      // If the Order is COMPLETE, became Hybrid and has only one row
      // We clone the last prescription and we add it as second row but without the pharmacy object
      // It means Doctor still needs to selects the pharmacy
      if (afterChangePharmacyOption && !lastDefaultPrescription && pharmacy_option && pharmacy_option.fulfilment_type === 3 && this.medications.length === 1) {

        var firstPrescription = angular.copy(this.medications[0]);
        firstPrescription.id = this.getFakeId(this.medications);
        firstPrescription.sent = null;
        if (firstPrescription.pharmacy) {
          delete firstPrescription["pharmacy"];
        }
        this.medications.push(firstPrescription);
      }
      */

      this.cachePrescriptions();
      this.setFocusEventsPrescriptionEditor();

      this.shouldHideSearchAndAddButton();

      // COMMENTED FOR BOOTS
      //
      // this.determineWhatMedicationsNeedPolling();
    }

    shouldHideSearchAndAddButton() {
      return (
        this.medications.length &&
        this.medications.every(
          med =>
            (med.is_bundle && this.medications.length === 1) ||
            ((!med.is_bundle || !med.parent_id) && this.hide_add_prescription_button) ||
            med.parent_id,
        )
      );
    }

    canMedicationBeDebundled() {
      return this.medications.length === 1 && this.medications.every(med => med.is_bundle);
    }

    hasMixOfBundleAndStandardMedications() {
      return this.medications.length && this.hasBundleMedication() && this.medications.some(med => !med.is_bundle);
    }

    hasBundleBeenDebundled() {
      return this.medications.length && this.medications.every(med => med.parent_id);
    }

    hasBundleMedication() {
      return this.medications.some(med => med.is_bundle);
    }

    isMedicationsSaved() {
      return (
        this.Orders.getTaskByType(
          this.Constants.VisitTasks.PrescribeMedication,
          this.Orders.current,
          this.Orders.current.flags.slv ? 2 : 1,
        ).status !== 0
      );
    }

    formatDefaultPrescription() {
      let fakeId = -1;

      this.visit.default_prescriptions.forEach(default_prescription => {
        if (default_prescription.code === this.visit.default_medication.code) {
          const { is_bundle, charge_type_id } = this.visit.default_medication;
          default_prescription = {
            ...default_prescription,
            is_bundle,
            default_no_substitutions: !default_prescription.default_no_substitutions,
            id: fakeId,
            days_supply: default_prescription.default_days_supply,
            dispense_amount: default_prescription.default_dispense_amount,
            no_substitutions: default_prescription.default_no_substitutions,
            num_refills: default_prescription.default_num_refills,
            pharmacy_notes: default_prescription.default_pharmacy_notes,
            short_directions: default_prescription.default_short_directions,
            charge_type_id: this.BOD_162_feature_flag_env ? charge_type_id : undefined,
          };
        }

        this.pushMedication(default_prescription);
        fakeId -= 1;
      });
    }

    numMedicationsNotSent(medications) {
      var numMedicationsNotSent = 0;

      if (!medications || !medications.length) return numMedicationsNotSent;

      medications.forEach(medication => {
        if (!medication.sent) numMedicationsNotSent++;
      });
      return numMedicationsNotSent;
    }

    isPrescribingDisabled() {
      // Make sure video task is approved before allowing completion
      let photosApproved;

      try {
        photosApproved = this.visit.getTask(this.Orders.TASKS.MULTI_PHOTO).status === this.Orders.STATUS.APPROVED;
      } catch (e) {
        photosApproved = true;
      }

      /**
       * Prescribing is disabled if:
       * 1. The photo task is not yet approved
       * 2. The visit has been rejected
       * 3. The visit is locked by another doctor
       */
      return (
        !photosApproved ||
        (typeof this.visit.isRejected === 'function' && this.visit.isRejected()) ||
        (typeof this.visit.isLocked === 'function' && this.visit.isLocked())
      );
    }

    getFilteredMedications(query) {
      return this.MedicationService.searchLemonaidMedications(this.visit.service.code, query).then(
        ({ data: medications }) =>
          medications.map(medications =>
            medications.code === 'ex-DUMMY-BUNDLE-ACNE-Lymecycline-Differin-6eaa31'
              ? { ...medications, is_bundle: true }
              : medications,
          ),
      );
    }

    getFakeId(medications) {
      if (!medications.length) return -1;

      return -1 * (medications.length + 1);
    }

    changeMedication(newMed) {
      if (!newMed) {
        return;
      }

      if (!newMed.errors) newMed.errors = {};

      const changeMedicationEach = (pharmacy = null) => {
        this.medicationQuery2 = null;
        this.selectedMedication2 = null;

        this.medications = this.medications.map((medication, index) => {
          if (medication.sent) {
            return medication;
          }

          const newMedication = angular.copy(newMed);
          const {
            code,
            dosespot_medication,
            medical_name,
            name,
            treatment_copy_code,
            default_days_supply,
            default_dispense_amount,
            default_no_substitutions,
            default_num_refills,
            default_pharmacy_notes,
            default_short_directions,
          } = newMedication;

          return {
            medication_id: newMedication.medication_id ? newMedication.medication_id : newMedication.id,
            id: newMedication.medication_id ? newMedication.id : -1 * (index + 1),
            pharmacy,
            code,
            dosespot_medication,
            medical_name,
            name,
            treatment_copy_code,
            days_supply: default_days_supply,
            dispense_amount: default_dispense_amount,
            no_substitutions: default_no_substitutions || false,
            num_refills: default_num_refills,
            pharmacy_notes: default_pharmacy_notes,
            short_directions: default_short_directions,
            saved: false,
          };
        });

        this.cachePrescriptions();
      };

      var fulfilment_type;

      if (this.pharmacyOption && this.pharmacyOption.fulfilment_type) {
        fulfilment_type = this.pharmacyOption.fulfilment_type;
      } else {
        fulfilment_type = 0;
      }

      if (fulfilment_type === 0 || fulfilment_type === 4) {
        var pharmacy = null;

        if (this.visit.pharmacy) pharmacy = this.visit.pharmacy;

        if (!pharmacy) {
          newMed.errors['pharmacy'] = 'Pharmacy is required.';
        } else {
          newMed.errors['pharmacy'] = '';
        }

        changeMedicationEach(pharmacy);
      } else {
        // FROM SPRINT 111:
        // NOW FOR MAILORDER OR HYBRID WE FIND THE RIGHT MAILORDER PHARMACY FIRST
        // THEN WE SET THAT PHARMACY WHEN WE ADD OR CHANGE MEDICATION

        var medication_id;

        if (!newMed.medication_id) {
          medication_id = newMed.id;
        } else {
          medication_id = newMed.medication_id;
        }

        this.Pharmacy.getMailorderPharmacy(medication_id, this.visit.state)
          .then(({ data }) => {
            var mailorderPharmacy = data;

            if (!mailorderPharmacy || !mailorderPharmacy.id) mailorderPharmacy = null;

            if (!mailorderPharmacy) {
              newMed.errors['pharmacy'] = 'Contact patient for local pharmacy. Not available via mail order.';
            } else {
              newMed.errors['pharmacy'] = '';
            }

            changeMedicationEach(mailorderPharmacy);
          })
          .catch(err => {
            newMed.errors['pharmacy'] = 'Contact patient for local pharmacy. Not available via mail order.';

            changeMedicationEach(null);
          });
      }
    }

    pushMedication(medication) {
      if (this.BOD_162_feature_flag_env) {
        if (medication.charge_type_id !== ChargeTypes.Help_Me_Choose) {
          this.medications = [...this.medications, medication];
          this.shouldHideSearchAndAddButton();
        }
      } else {
        this.medications = [...this.medications, medication];
        this.shouldHideSearchAndAddButton();
      }
    }

    addMedication(medication) {
      if (!medication) {
        return;
      }

      var this2 = this;
      // weird logic needed to ensure meds are not added twice ... refactor when chance
      this.medications = this.medications.filter(med => med.id !== medication.id);

      if (!medication.errors) medication.errors = {};

      const addMedicationEach = pharmacy => {
        var newMedication = angular.copy(medication);

        this2.medicationQuery = null;
        this2.selectedMedication = null;

        // Before we "Save Medication"
        // We need a fake ID for new prescriptions
        // For example to be able to delete the prescription on the UI
        // After we get response from backend the ID will be real ID's
        if (!newMedication.medication_id) newMedication.medication_id = newMedication.id;

        newMedication.id = this2.getFakeId(this2.medications);

        if (pharmacy) {
          newMedication.pharmacy = pharmacy;
        } else {
          newMedication.pharmacy = null;
        }

        //console.log(newMedication);
        this.pushMedication(newMedication);

        this2.cachePrescriptions();
        this2.setFocusEventsPrescriptionEditor();
      };

      var fulfilment_type;

      if (this.pharmacyOption && this.pharmacyOption.fulfilment_type) {
        fulfilment_type = this.pharmacyOption.fulfilment_type;
      } else {
        fulfilment_type = 0;
      }

      if (fulfilment_type === 0 || fulfilment_type === 4) {
        var pharmacy = null;

        if (this.visit.pharmacy) pharmacy = this.visit.pharmacy;

        if (!pharmacy) {
          medication.errors['pharmacy'] = 'Pharmacy is required.';
        } else {
          medication.errors['pharmacy'] = '';
        }

        addMedicationEach(pharmacy);
      } else {
        // FROM SPRINT 111:
        // NOW FOR MAILORDER OR HYBRID WE FIND THE RIGHT MAILORDER PHARMACY FIRST
        // THEN WE SET THAT PHARMACY WHEN WE ADD OR CHANGE MEDICATION

        var medication_id;

        if (medication.medication_id) {
          medication_id = medication.medication_id;
        } else {
          medication_id = medication.id;
        }

        this.Pharmacy.getMailorderPharmacy(medication_id, this.visit.state)
          .then(({ data }) => {
            var mailorderPharmacy = data;

            if (!mailorderPharmacy || !mailorderPharmacy.id) mailorderPharmacy = null;

            if (!mailorderPharmacy) {
              medication.errors['pharmacy'] = 'Contact patient for local pharmacy. Not available via mail order.';
            } else {
              medication.errors['pharmacy'] = '';
            }

            addMedicationEach(mailorderPharmacy);
          })
          .catch(err => {
            medication.errors['pharmacy'] = 'Contact patient for local pharmacy. Not available via mail order.';

            addMedicationEach(null);
          });
      }
    }

    removeMedication(medication) {
      const removeMed = () => {
        const idx = this.medications.findIndex(m => m.id === medication.id);
        this.medications.splice(idx, 1);

        // HERE WE NEED TO REASSIGN THE medication.id ACCORDING TO THE INDEX NUMBER
        this.medications.forEach((medication, index) => {
          if (medication.id < 0) {
            medication.id = -1 * (index + 1);
          }
        });

        this.cachePrescriptions();
        this.automaticSaveMedicationsToOrder();

        this.shouldHideSearchAndAddButton();
      };

      if (medication.id && medication.id > 0) {
        this.MedicationService.removePrescription(this.visit.id, medication.id)
          .then(() => {
            removeMed();
          })
          .catch(err => {
            this.toastr.error('Failed to delete the prescription.');
          });
      } else {
        removeMed();
      }
    }

    confirmPharmacyTask() {
      this.Orders.updateTask(this.pharmacyTaskId, this.Constants.VisitStatuses.Approved)
        .then(() => {
          this.toastr.success('Pharmacy confirmed.');
          this.$rootScope.$broadcast('visit:refresh');
          this.pharmacyTaskPending = false;
        })
        .catch(err => {
          this.toastr.error('Error confirming pharmacy.');
        });
    }

    isMedicationValid(medication, fulfilment_type) {
      const errors = {};
      const dispenseRegex = /^(?=.{1,11}$)(\d+)?([.]?\d+)?$/gi;

      // We validate if user selected pharmacy (required)
      // For new prescriptions only (prescriptions not sent)
      if (!medication.sent && !medication.pharmacy) {
        // If pharmacy option is PICKUP or HYBRID
        if (fulfilment_type === 0 || fulfilment_type === 3 || fulfilment_type === 4) {
          errors['pharmacy'] = 'Pharmacy is required.';
        }

        // If pharmacy option is MAILORDER (ONE TIME or RECURRING)
        if (fulfilment_type == 1 || fulfilment_type == 2) {
          errors['pharmacy'] = 'Mailorder pharmacy is required.';
        }
      }

      // eslint-disable-next-line complexity
      Object.keys(medication).forEach(key => {
        if (medication.sent) {
          return;
        }

        const value = medication[key];

        switch (key) {
          // eslint-disable-next-line no-case-declarations
          case 'dispense_amount':
            const amount = parseFloat(value);
            if (amount === 0) {
              errors[key] = 'Dispense amount may not be zero';
            }

            if (value && !dispenseRegex.test(value)) {
              errors[key] = 'Dispense amount may be no longer than 11 digits or 10 digits with 1 decimal';
            }

            if (!value) {
              errors[key] = 'Dispense amount is required';
            }
            break;
          case 'days_supply':
            const supply = parseInt(value, 10);
            if (`${value}`.includes('.')) {
              errors[key] = 'Days supply may not contain a decimal.';
              break;
            }

            if (isNaN(supply)) {
              errors[key] = 'Days supply must be between 1 and 365.';
              break;
            }

            if (supply && (supply < 1 || supply > 365)) {
              errors[key] = 'Days supply must be between 1 and 365.';
              break;
            }
            break;
          case 'num_refills':
            if (`${value}`.includes('.')) {
              errors[key] = 'Refills may not be a decimal.';
            }

            if (value < 0 || value > 99) {
              errors[key] = 'Refills must be between 0 and 99.';
            }

            if (value === null || value === undefined || (typeof value === 'string' && !value.length)) {
              errors[key] = 'Refills is required';
            }

            break;
          case 'short_directions':
            if (!value || value.length > 255) {
              errors[key] = 'Patient directions are required and must be no more than 255 characters.';
            }
            break;
          case 'pharmacy_notes':
            if (value && value.length > 255) {
              errors[key] = 'Pharmacy notes must be no more than 255 characters.';
            }
            break;
          case 'no_substitutions':
          default:
            break;
        }
      });

      const isMedicationValid = Object.keys(errors).length === 0;
      medication.errors = isMedicationValid ? null : errors;

      return isMedicationValid;
    }

    showPharmacyOptionsDropdown() {
      const isOnlyPickup =
        this.pharmacyOptions.length === 1 &&
        [...PICKUP_IDS_ARRAY, ...HYBRID_PICKUP_IDS_ARRAY].includes(this.pharmacyOptions[0].code);

      return this.BOD_2442 ? this.pharmacyOptions.length > 1 || isOnlyPickup : this.pharmacyOptions.length > 1;
    }

    areAllMedicationsValid(medications) {
      let fulfilment_type = 0; // DEFAULT BEFORE CHECKING

      if (
        this.visit.order_lines.length &&
        this.visit.order_lines[0].pharmacy_option &&
        this.visit.order_lines[0].pharmacy_option.fulfilment_type
      ) {
        fulfilment_type = this.visit.order_lines[0].pharmacy_option.fulfilment_type;
      }

      return medications.every(m => this.isMedicationValid(m, fulfilment_type));
    }

    hasMedications() {
      const { medications } = this;

      if (!medications || !medications.length) return false;

      return true;
    }

    // disabled when all medications are saved
    areAllMedicationsSaved() {
      const { medications } = this;

      if (!medications || !medications.length) return false;

      return medications.every(m => m.saved);
    }

    // disabled when all medications are saved and have an attached dosespot med
    areAllMedicationsSavedAndPaired() {
      const { medications } = this;

      if (!medications || !medications.length) return false;

      return medications.every(m => m.saved && m.dosespot_medication);
    }

    haveAllMedicationsBeenSent() {
      const { medications } = this;

      if (!medications || !medications.length) return false;

      return medications.every(m => m.sent || [ChargeTypes.Coaching].includes(m.charge_type_id));
    }

    markAllMedicationsAsSaved() {
      this.medications.forEach(m => {
        m.saved = true;
      });
    }

    noDummyMedicationsToBeSent() {
      const { medications } = this;

      if (!medications || !medications.length) return true;

      return medications.every(m => m.sent || (!m.sent && m.code.substring(0, 5).toLowerCase() != 'dummy'));
    }

    haveMedicationsToBeSent() {
      var num = 0;

      if (!this.medications || !this.medications.length) return false;

      this.medications.forEach(medication => {
        if (!medication.sent) num++;
      });

      if (num) this.no_med_prescribed = false;

      if (num) return true;
      else return false;
    }

    anyMedicationHasBeenSent() {
      var num = 0;

      if (!this.medications || !this.medications.length) return false;

      this.medications.forEach(medication => {
        if (medication.sent) num++;
      });

      if (num) return true;
      else return false;
    }

    hasMedicationsNotSaved() {
      var numNotSaved = 0;

      if (!this.medications || !this.medications.length) return false;

      this.medications.forEach(medication => {
        if (!medication.saved) numNotSaved++;
      });

      if (numNotSaved) return true;
      else return false;
    }

    automaticSaveMedicationsToOrder() {
      const isLocked = typeof this.visit.isLocked === 'function' ? this.visit.isLocked() : false;
      if (
        this.medications.length &&
        this.haveMedicationsToBeSent() &&
        !this.hasBundleMedication() &&
        !this.saveMedicationsDisabled &&
        !(typeof this.visit.isLocked === 'function' && this.visit.isLocked())
      ) {
        this.saveMedicationsToOrder();
      }
    }

    rebundleMedications() {
      this.bundlingMedications = true;
      this.Orders.bundlePrescriptions(this.visit.id).then(() => {
        this.Orders.getOne(this.visit.id).then(({ data: visit }) => {
          this.medications = [];
          this.formatDefaultPrescription();
          this.shouldHideSearchAndAddButton();
          this.bundlingMedications = false;
          this.visit = new Order(visit);
          this.orderline = visit.order_lines[0];
          this.cachePrescriptions();

          this.toastr.success('Prescription changes were saved.');
          this.$rootScope.$broadcast('visit:refresh');
        });
      });
    }

    saveMedicationsToOrder() {
      // We only validate and save medications that have not been sent
      var medicationsNotSent = [];
      var numDummyMedications = 0;

      this.medications.forEach(medication => {
        if (!medication.sent) {
          medicationsNotSent.push(medication);

          if (medication.code.substring(0, 5).toLowerCase() == 'dummy') numDummyMedications++;
        }
      });

      // WE PREVENT TO PRESCRIBE DUMMY MEDICATIONS
      if (numDummyMedications) {
        this.toastr.error('Please remove any dummy medication from the prescription.');
        return;
      }

      if (!this.areAllMedicationsValid(medicationsNotSent)) {
        this.toastr.error(INVALID_PRESCRIPTION_MESSAGE);
        return;
      }

      this.postingMedications = true;
      this.currentMedications = medicationsNotSent;

      // JUST FOR QA TEAM TESTING
      // TEMPORARY TIMEOUT OF 3 SECONDS
      // this.$timeout(() => {

      //this.Orders.postMedications(this.visit.id, medicationsNotSent)
      this.Orders.putPrescriptions(this.visit.id, medicationsNotSent)
        .then(() => {
          this.Orders.getOne(this.visit.id)
            .then(({ data: visit }) => {
              this.postingMedications = false;
              this.visit = new Order(visit);
              this.orderline = visit.order_lines[0];

              //this.medications = visit.order_lines[0].medications;
              this.medications = visit.prescriptions;
              this.markAllMedicationsAsSaved();

              // THIS FIX THE BUG WHEN WE UPDATE THE PHARMACY
              // BUT THE CACHE STILL SHOWING THE OLD PHARMACY
              this.cachePrescriptions();

              this.toastr.success('Prescription changes were saved.');
              this.$rootScope.$broadcast('visit:refresh');
            })
            .catch(err => {
              this.postingMedications = false;

              // THIS FIX THE BUG WHEN WE UPDATE THE PHARMACY
              // BUT THE CACHE STILL SHOWING THE OLD PHARMACY
              this.cachePrescriptions();

              this.toastr.error('Error getting order details.');
            });
        })
        .catch(({ data: err }) => {
          this.postingMedications = false;
          var error = err.message.summary;

          //status: 409 + code: 4 => message: {summary: "All tasks are not approved"}
          if (err.status === 409 && err.code === 4) {
            var pharmacyTask = this.Orders.getTaskByType(this.Constants.VisitTasks.Delivery, this.Orders.current, 0);
            if (pharmacyTask && pharmacyTask.status != this.Constants.VisitStatuses.Approved) {
              error = 'Pharmacy task is not approved';
            }
          }

          //this.Utils.createErrorToast(err, 'Failed to create prescriptions.');
          this.toastr.error(error);
        });

      // JUST FOR QA TEAM TESTING
      // TEMPORARY TIMEOUT OF 3 SECONDS
      // }, 3000);
    }

    slvCheckedOk() {
      const { visit } = this;
      const { TASKS: VisitTasks, STATUS: VisitStatus } = this.Orders;

      // If there is not SLV task required
      if (!visit.flags.slv) return true;

      // If there is SLV task required
      // Make sure video task is approved before allowing completion
      if (visit.flags.slv) {
        const { status: slvTaskStatus } = visit.getTask(VisitTasks.SMART_LIVE_VIDEO);
        if (slvTaskStatus === VisitStatus.OPEN || slvTaskStatus === VisitStatus.REJECTED) {
          return false;
        }
      }

      return true;
    }

    canSendPrescriptions() {
      const { visit } = this;
      const { TASKS: VisitTasks, STATUS: VisitStatus } = this.Orders;

      // Make sure video task is approved before allowing completion
      if (visit.flags.slv) {
        const { status: slvTaskStatus } = visit.getTask(VisitTasks.SMART_LIVE_VIDEO);
        if (slvTaskStatus === VisitStatus.OPEN || slvTaskStatus === VisitStatus.REJECTED) {
          return false;
        }
      }

      // We can send prescriptions if:
      // 1. We're not already sending Prescriptions
      // 2. Prescribing is not disabled due to other reasons
      // 3. All medications have a dosespot medication and have been saved to the orderline
      // 4. There are medications that have not been sent
      try {
        return (
          !this.completingVisit &&
          // ADDED FOR BOOTS
          this.hasMedications() &&
          this.areAllMedicationsSaved() &&
          // COMMENTED FOR BOOTS
          // && this.areAllMedicationsSavedAndPaired()

          // && this.visit.pharmacy
          !this.isPrescribingDisabled() &&
          !this.haveAllMedicationsBeenSent()
        );
      } catch (e) {
        return false;
      }
    }

    /*
    sendPrescriptionChargePickupMailorder(buttonLabel, numPickupNotSent, numMailorderNotSent, newPrescriptionsArray, validUnitPrice) {

      var successMessage;
      var errorMessage;
      var stayMessage;

      if (buttonLabel === 'Send prescription') {
        successMessage = 'Prescription sent.';
        errorMessage = 'Failed to send prescription';
        stayMessage = 'Please stay here until the prescription is complete.';
      } else {
        successMessage = 'Visit completed.';
        errorMessage = 'Failed to complete visit';
        stayMessage = 'Please stay here until the visit is complete.';
      }

      // Adds an event listener to detect if the browser window/tab is closed.
      // We want to prevent the window being closed until the prescription process
      // is complete.
      this.$window.onbeforeunload = () => {
        return stayMessage;
      };

      this.completingVisit = true;

      // WE CREATED THIS SWITCH FOR TESTING
      // TO REPRODUCE THE SCENARIO WHEN ONE VISIT IS LEFT OPEN
      // WHEN PRESCRIPTION WAS CREATED AND/OR SENT TO DOSESPOT
      // BUT VISIT WAS NOT FINALIZED FOR SOME REASON

      // NOTICE:
      // SWITCH MUST BE CHANGED ON 2 FILES:
      // prescribe.js (this file)
      // order.service.ts

      var makingVisitLeftOpenAndNotFinalized = false;

      if (!makingVisitLeftOpenAndNotFinalized) {

        // NORMAL CODE

        this.Orders
        .getOne(this.visit.id)
        .then(({ data }) => {
          this.visit.order_lines = data.order_lines;
        })
        .then(() => this.Orders.performCompletionSeries(this.visit))
        .then(({ data: visit }) => {

          this.visit = new Order(visit);
          this.orderline = visit.order_lines[0];
          //this.medications = this.orderline.medications;
          this.medications = visit.prescriptions;
          this.markAllMedicationsAsSaved();
          this.cachePrescriptions();

          // COMMENTED FOR BOOTS
          //
          // this.determineWhatMedicationsNeedPolling();

          this.toastr.success(successMessage);

          this.$rootScope.$broadcast('visit:completed');
          this.$rootScope.$broadcast('visit:refresh');

          var show_charge_popup = false;

          if (this.pimsParameters && this.pimsParameters.pimsVisitParameters &&
            this.pimsParameters.pimsVisitParameters.always_show_charge_popup_for_mailorder_prescription &&
            this.pimsParameters.pimsVisitParameters.always_show_charge_popup_for_mailorder_prescription.length) {

            this.pimsParameters.pimsVisitParameters.always_show_charge_popup_for_mailorder_prescription.forEach((service) => {
              if (this.visit.service.code == service) show_charge_popup = true;
            });
          }

          // MEDICATION CHARGE POPUP
          if ((numPickupNotSent + numMailorderNotSent) > 0 && (validUnitPrice || show_charge_popup)) {

            this.completingVisit = false;
            this.openChargeDialog(newPrescriptionsArray, (result) => {

              // IF PAYMENT WAS SUCCESSFUL
              if (result) {

              } else {

                console.log("Charge popup closed");
              }

              // WE SHOW TREATMENT PLAN POPUP AND WE UNLOCK THE VISIT AFTER USER IS DONE WITH POPUP
              this.Orders.showTreatmentPlanPopup(this.visit);

            });

          } else if (this.medications.length > 0) {

            // WE SHOW TREATMENT PLAN POPUP AND WE UNLOCK THE VISIT AFTER USER IS DONE WITH POPUP
            this.Orders.showTreatmentPlanPopup(this.visit);

          }
        })
        .catch((err) => {
          this.Utils.createErrorToast(err, errorMessage);
          this.Tracking.trackError(err, 'pimsSendPrescription', 'Visit Details');

          // Example of action tracking:
          // this.Tracking.trackAction('click', [ 'Prescribe Tab', 'Send Prescription' ], 'Visit Details');
        })
        .finally(() => {
          this.completingVisit = false;
          // Remove the event listener to detect window closure.
          this.$window.onbeforeunload = () => {};
        });

      } else {

        // TESTING CODE

        this.Orders
        .getOne(this.visit.id)
        .then(({ data }) => {
          this.visit.order_lines = data.order_lines;
        })
        .then(() => this.Orders.performCompletionSeries(this.visit))
        .then(({ data: visit }) => {

        })
        .finally(() => {
          this.completingVisit = false;
          // Remove the event listener to detect window closure.
          this.$window.onbeforeunload = () => {};
        });
      }
    }
*/

    completeVisit() {
      this.completeVisitNewFlowOrder();
    }

    showChargeMedicationAfterVisitCompleted() {
      if (!this.visitIsComplete()) return false;

      if (!this.hasMedications()) return false;

      if (!this.haveAllMedicationsBeenSent()) return false;

      if (this.isPrescribingDisabled()) return false;

      //IF MEDICATION HAS BEEN CHARGED, THEN RETURN FALSE
      if (
        this.visit &&
        this.visit.order_lines &&
        this.visit.order_lines[0] &&
        this.visit.order_lines[0].medication_charge_id
      )
        return false;

      return true;
    }

    /*
    chargeVisitCompletedNotCharged() {

      var numPickup = 0;
      var numMailorder = 0;
      var numPickupTotal = 0;
      var numMailorderTotal = 0;
      var validUnitPrice = false;
      var newPrescriptionsArray = [];

      this.visit.prescriptions.forEach((prescription) => {
        if (prescription.sent) {
          newPrescriptionsArray.push(prescription);
          // if (prescription.unit_price && prescription.unit_price > 0) validUnitPrice = true;
          if (prescription.pharmacy && prescription.pharmacy.mailorder_partner) numMailorder++;
          if (prescription.pharmacy && !prescription.pharmacy.mailorder_partner) numPickup++;
        }
      });

      // MEDICATION CHARGE POPUP
      if ((numPickup + numMailorder) > 0) {

        this.completingVisit = false;
        this.openChargeDialog(newPrescriptionsArray, (result) => {

          // IF PAYMENT WAS SUCCESSFUL
          if (result) {

            this.Orders
            .getOne(this.visit.id)
            .then(({ data: visit }) => {

              this.visit = new Order(visit);
              this.orderline = visit.order_lines[0];
              this.medications = visit.prescriptions;

              // this.markAllMedicationsAsSaved();
              this.cachePrescriptions();

              // this.$rootScope.$broadcast('visit:completed');
              this.$rootScope.$broadcast('visit:refresh');
            })
            .catch((err) => {

              // Example of action tracking:
              // this.Tracking.trackAction('click', [ 'Prescribe Tab', 'Send Prescription' ], 'Visit Details');
            });

          } else {

            console.log("Charge popup closed");
          }
        });
      }
    }
*/

    completeVisitNewFlowOrder() {
      var buttonLabel = this.getSendButtonText();

      // WE NEED TO COUNT FIRST HOW MANY:
      // PICKUP "NOT SENT" PRESCRIPTIONS ARE
      // MAILORDER "NOT SENT" PRESCRIPTIONS ARE

      var numPickupNotSent = 0;
      var numMailorderNotSent = 0;
      var numPickupTotal = 0;
      var numMailorderTotal = 0;
      var validUnitPrice = false;
      var newPrescriptionsArray = [];

      this.medications.forEach(prescription => {
        if (!prescription.sent) {
          newPrescriptionsArray.push(prescription);
          if (prescription.unit_price && prescription.unit_price > 0) validUnitPrice = true;
          if (prescription.pharmacy && prescription.pharmacy.mailorder_partner) numMailorderNotSent++;
          if (prescription.pharmacy && !prescription.pharmacy.mailorder_partner) numPickupNotSent++;
        }

        if (prescription.pharmacy && prescription.pharmacy.mailorder_partner) numMailorderTotal++;
        if (prescription.pharmacy && !prescription.pharmacy.mailorder_partner) numPickupTotal++;
      });

      // VALIDATION IF ARRAY OF PRESCRIPTIONS MATCHES THE CURRENT PHARMACY OPTION

      const medicationsNotSent = this.medications.filter(m => !m.sent);
      if (medicationsNotSent.length && !this.areAllMedicationsValid(medicationsNotSent)) {
        this.toastr.error(INVALID_PRESCRIPTION_MESSAGE);
        return;
      }

      if (!this.serviceCanSkipPrescription()) {
        if (this.pharmacyOption && this.pharmacyOption.fulfilment_type) {
          var fulfilment_type = this.pharmacyOption.fulfilment_type;

          if ((fulfilment_type === 0 || fulfilment_type === 3 || fulfilment_type === 4) && numPickupTotal === 0) {
            this.toastr.error(
              'The current pharmacy option (' +
                this.pharmacyOption.code +
                ') requires at least one prescription with pickup pharmacy.',
            );
            return;
          }

          if ((fulfilment_type === 1 || fulfilment_type === 2 || fulfilment_type === 3) && numMailorderTotal === 0) {
            this.toastr.error(
              'The current pharmacy option (' +
                this.pharmacyOption.code +
                ') requires at least one prescription with mailorder pharmacy.',
            );
            return;
          }
        } else {
          // if the current visit has no pharmacy options
          // then we assume the pharmacy option is pickup (fulfilment_type = 0)
          var fulfilment_type = 0;

          if (!this.parent.serviceHasLabs && numPickupTotal === 0) {
            this.toastr.error('This visit requires at least one prescription with pickup pharmacy.');
            return;
          }
        }
      }

      // VALIDATION WHEN BACKEND FORGOT TO CONFIGURE MEDICATION PRICE FOR THE SERVICE
      // var medication_charge_required = this.Orders.checkMedicationPriceRequired(this.visit.service.code);

      // if (medication_charge_required && numMailorderNotSent > 0 && !validUnitPrice) {
      //   this.toastr.error("Medication price has not been configured for the service " + this.visit.service.name);
      //   return;
      // }

      // MEDICATION CHARGE POPUP
      var show_charge_popup = false;

      if (
        this.pimsParameters &&
        this.pimsParameters.pimsVisitParameters &&
        this.pimsParameters.pimsVisitParameters.always_show_charge_popup_for_mailorder_prescription &&
        this.pimsParameters.pimsVisitParameters.always_show_charge_popup_for_mailorder_prescription.length
      ) {
        this.pimsParameters.pimsVisitParameters.always_show_charge_popup_for_mailorder_prescription.forEach(service => {
          if (this.visit.service.code == service) show_charge_popup = true;
        });
      }

      // CHECK IF ANY MEDICATION HAS ALREADY BEEN CHARGED
      var medication_already_charged = false;

      if (
        this.visit &&
        this.visit.order_lines &&
        this.visit.order_lines[0] &&
        this.visit.order_lines[0].medication_charge_id
      )
        medication_already_charged = true;

      // if (!medication_already_charged && (numPickupNotSent + numMailorderNotSent) > 0 && (validUnitPrice || show_charge_popup)) {
      if (!medication_already_charged && numPickupNotSent + numMailorderNotSent > 0) {
        this.completingVisit = false;
        this.openChargeDialog(newPrescriptionsArray, result => {
          // IF PAYMENT WAS SUCCESSFUL
          if (result === true) {
            // SEND PRESCRIPTION
            this.sendPrescriptionNewFlowOrder(
              buttonLabel,
              numPickupNotSent,
              numMailorderNotSent,
              newPrescriptionsArray,
              validUnitPrice,
            );
          } else if (result && result.status === 'paymentFailed') {
            // Handle payment failures with detailed results
            const { medSuccess, medFailed, nonMedSuccess, nonMedFailed } = result.results;
            const totalMed = medSuccess + medFailed;
            const totalNonMed = nonMedSuccess + nonMedFailed;

            // Determine overall outcome
            let outcomeMessage = '';
            if (medFailed > 0 && nonMedFailed > 0) {
              outcomeMessage = 'Both medication and non-medication payments failed.';
            } else if (medFailed > 0) {
              outcomeMessage =
                totalNonMed > 0
                  ? 'Medication payment failed. Non-medication payment failed.'
                  : 'Medication payment failed.';
            } else if (nonMedFailed > 0) {
              outcomeMessage =
                totalMed > 0
                  ? 'Non-medication payment failed. Medication payment was successful.'
                  : 'Non-medication payment failed.';
            }

            // Show modal with appropriate message
            this.callRejectModal(() => {
              this.$rootScope.$broadcast('payment:error');
            }, outcomeMessage);
          } else {
            console.log('Charge popup closed');
          }
        });
      } else {
        // SEND PRESCRIPTION
        this.sendPrescriptionNewFlowOrder(
          buttonLabel,
          numPickupNotSent,
          numMailorderNotSent,
          newPrescriptionsArray,
          validUnitPrice,
        );
      }
    }

    sendPrescriptionNewFlowOrder(
      buttonLabel,
      numPickupNotSent,
      numMailorderNotSent,
      newPrescriptionsArray,
      validUnitPrice,
    ) {
      var successMessage;
      var errorMessage;
      var stayMessage;

      if (buttonLabel === 'Send prescription') {
        successMessage = 'Prescription sent.';
        errorMessage = 'Failed to send prescription';
        stayMessage = 'Please stay here until the prescription is complete.';
      } else {
        successMessage = 'Visit completed.';
        errorMessage = 'Failed to complete visit';
        stayMessage = 'Please stay here until the visit is complete.';
      }

      /* Adds an event listener to detect if the browser window/tab is closed.
      We want to prevent the window being closed until the prescription process
      is complete. */
      this.$window.onbeforeunload = () => {
        return stayMessage;
      };

      this.completingVisit = true;

      // WE CREATED THIS SWITCH FOR TESTING
      // TO REPRODUCE THE SCENARIO WHEN ONE VISIT IS LEFT OPEN
      // WHEN PRESCRIPTION WAS CREATED AND/OR SENT TO DOSESPOT
      // BUT VISIT WAS NOT FINALIZED FOR SOME REASON

      // NOTICE:
      // SWITCH MUST BE CHANGED ON 2 FILES:
      // prescribe.js (this file)
      // order.service.ts

      var makingVisitLeftOpenAndNotFinalized = false;

      if (!makingVisitLeftOpenAndNotFinalized) {
        // NORMAL CODE

        this.Orders.getOne(this.visit.id)
          .then(({ data }) => {
            this.visit.order_lines = data.order_lines;
          })
          .then(() => this.Orders.performCompletionSeries(this.visit))
          .then(({ data: visit }) => {
            this.visit = new Order(visit);
            this.orderline = visit.order_lines[0]; //this.medications = this.orderline.medications;

            visit.prescriptions.forEach(prescription => this.addMedication(prescription));

            this.markAllMedicationsAsSaved();
            this.cachePrescriptions();

            // COMMENTED FOR BOOTS
            //
            // this.determineWhatMedicationsNeedPolling();

            this.toastr.success(successMessage);

            this.$rootScope.$broadcast('visit:completed');
            this.$rootScope.$broadcast('visit:refresh');

            // AFTER VISIT COMPLETION, WE CREATE AN AUTOMATIC VISIT NOTE IF THE SERVICE HAS SET A NOTE ON THE CMS CONTENT > PIMS PARAMETERS
            // https://23andme.atlassian.net/browse/LMNUK-102

            if (
              this.visit_note_after_visit_completion &&
              (!this.validate_no_medication_prescribed_checkbox ||
                (this.validate_no_medication_prescribed_checkbox && this.no_med_prescribed))
            ) {
              this.$rootScope.$broadcast('create-visit-note', this.visit_note_after_visit_completion);
            }

            // WE SHOW TREATMENT PLAN POPUP AND WE UNLOCK THE VISIT AFTER USER IS DONE WITH POPUP
            if (numPickupNotSent + numMailorderNotSent > 0) this.Orders.showTreatmentPlanPopup(this.visit);
          })
          .catch(err => {
            this.Utils.createErrorToast(err, errorMessage);
            this.Tracking.trackError(err, 'pimsSendPrescription', 'Visit Details');

            // Example of action tracking:
            // this.Tracking.trackAction('click', [ 'Prescribe Tab', 'Send Prescription' ], 'Visit Details');
          })
          .finally(() => {
            this.completingVisit = false;
            // Remove the event listener to detect window closure.
            this.$window.onbeforeunload = () => {};
          });
      } else {
        // TESTING CODE

        this.Orders.getOne(this.visit.id)
          .then(({ data }) => {
            this.visit.order_lines = data.order_lines;
          })
          .then(() => this.Orders.performCompletionSeries(this.visit))
          .then(({ data: visit }) => {})
          .finally(() => {
            this.completingVisit = false;
            // Remove the event listener to detect window closure.
            this.$window.onbeforeunload = () => {};
          });
      }
    }

    canFinalizeVisit() {
      return (
        this.visit.admin_status == this.Constants.AdminStatuses.RemoteRxCreated.NumericValue ||
        this.visit.admin_status == this.Constants.AdminStatuses.RemoteRxSent.NumericValue
      );
    }

    visitIsComplete() {
      return this.visit.admin_status == this.Constants.AdminStatuses.Complete.NumericValue;
    }

    labOrderHasBeenSent() {
      return (
        this.serviceHasLabs() &&
        (this.visit.admin_status == this.Constants.AdminStatuses.LabOrderSent.NumericValue ||
          this.visit.admin_status == this.Constants.AdminStatuses.LabResultsReceived.NumericValue ||
          this.visit.admin_status == this.Constants.AdminStatuses.MedicinePrescribed.NumericValue ||
          this.visit.admin_status == this.Constants.AdminStatuses.RemoteRxCreated.NumericValue ||
          this.visit.admin_status == this.Constants.AdminStatuses.RemoteRxSent.NumericValue ||
          this.visit.admin_status == this.Constants.AdminStatuses.Complete.NumericValue)
      );
    }

    serviceHasLabs() {
      return this.parent.serviceHasLabs;
    }

    phoneCallDone() {
      var phoneCallDone = false;

      if (this.visit.flags.slv) {
        return true;
      }

      if (this.visit.phone_call.is_phone_call_required == 1 && this.visit.phone_call.phone_call_completed == null) {
        phoneCallDone = false;
      } else {
        phoneCallDone = true;
      }
      return phoneCallDone;
    }

    serviceCanSkipPrescription() {
      if (this.haveMedicationsToBeSent()) return true;

      return (
        this.allow_skip_prescription_whole_service &&
        (!this.validate_no_medication_prescribed_checkbox ||
          (this.validate_no_medication_prescribed_checkbox && this.no_med_prescribed))
      );
    }

    openChargeDialog(newMailorderPrescriptionsArray, callback) {
      const { visit } = this;

      return this.ngDialog.open({
        templateUrl: 'app/components/charge-mailorder-completevisit/charge-mailorder-completevisit.html',

        // To not allow the user closes the modal without explicitely to have some action

        showClose: false,
        closeByEscape: false,
        closeByNavigation: false,
        closeByDocument: false,

        controller: 'ChargeMailOrderCompleteVisitController',
        controllerAs: 'mailorder',
        className: 'ngdialog-theme-default charge-completevisit-modal',
        data: {
          visit,
          newMailorderPrescriptionsArray,
        },
        preCloseCallback(res) {
          return callback(res);
        },
      });
    }

    callRejectModal(callback, customMessage) {
      return this.ngDialog.open({
        templateUrl: 'app/components/reject-mailorder-completevisit/reject-mailorder-completevisit.html',
        showClose: false,
        closeByEscape: false,
        closeByNavigation: false,
        closeByDocument: false,
        controller: 'RejectMailOrderCompleteVisitController',
        controllerAs: 'reject',
        data: {
          message: customMessage,
        },
        preCloseCallback(res) {
          callback(res);
          return true;
        },
      });
    }

    getSendButtonText() {
      const { visit } = this;

      if (typeof visit.isRejected === 'function' && visit.isRejected()) {
        return 'Not Treated';
      }

      if (!this.slvCheckedOk()) {
        return 'SLV required';
      }

      if (!this.phoneCallDone()) {
        return 'Phone call required';
      }

      if (this.serviceHasLabs() && !this.labOrderHasBeenSent()) {
        return 'Lab Order not sent';
      }

      if (!this.noDummyMedicationsToBeSent()) {
        return 'Remove dummy medications';
      }

      if (this.canSendPrescriptions()) {
        return 'Send prescription';
      }

      if (this.canFinalizeVisit()) {
        return 'Finalize Visit';
      }

      if (this.serviceHasLabs()) {
        return 'Complete Visit';
      }

      if (this.serviceCanSkipPrescription()) {
        return 'Complete Visit';
      }

      if (this.visitIsComplete()) {
        return 'Visit complete';
      }

      return 'Visit not ready';
    }

    determineWhatMedicationsNeedPolling() {
      if (!this.medications || !this.medications.length) {
        return;
      }

      this.resetAllPollingPrescriptionStatus();

      this.dosespot_api_calls_in_progress = {};

      this.medications.forEach(m => {
        if (m.dosespot_prescription_id && !m.remote_status) {
          this.startPollingPrescriptionStatus(m);
        }
      });
    }

    resetAllPollingPrescriptionStatus() {
      if (!this.medications || !this.medications.length) {
        return;
      }

      this.medications.forEach(m => {
        this.stopPollingPrescriptionStatus(m);
      });
    }

    startPollingPrescriptionStatus(medication) {
      this.getPrescriptionStatus(medication);

      this.polls[medication.id] = setInterval(this.getPrescriptionStatus.bind(this, medication), 5000);
    }

    getPrescriptionStatus(medication) {
      if (this.dosespot_api_calls_in_progress[medication.id]) return;

      this.dosespot_api_calls_in_progress[medication.id] = true;

      this.Orders.getPrescriptionStatus(medication.dosespot_prescription_id)
        // this.Orders.getPrescriptionStatus_Fake(medication.dosespot_prescription_id)
        .then(({ data }) => {
          this.dosespot_api_calls_in_progress[medication.id] = false;

          const { latest_status: remote_status } = data;

          switch (remote_status) {
            case 'PharmacyVerified':
            case 'eRxSent':
            case 'Error':
              this.stopPollingPrescriptionStatus(medication);
              break;
            default:
              break;
          }

          medication.remote_status = remote_status;

          this.cachePrescriptions();
        })
        .catch(err => {
          this.dosespot_api_calls_in_progress[medication.id] = false;

          this.$log.debug(err);
        });
    }

    stopPollingPrescriptionStatus(medication) {
      if (this.polls[medication.id]) {
        clearInterval(this.polls[medication.id]);
        this.polls[medication.id] = null;
      }
    }

    treatmentPlanPendingToSend() {
      if (
        _.includes(this.currentUser.roles, this.Users.ROLES.DOCTOR.NAME) &&
        this.Orders.hasTreatmentPlansNotSent(this.Orders.current)
      )
        return true;
      return false;
    }

    openCreatePimsMedPopup() {
      this.MedicationService.showCreatePimsMedPopup(this.Orders.current);
    }

    openTreatmentPlanPopup() {
      this.Orders.showTreatmentPlanPopup(this.Orders.current);
    }

    savePhoneCallCompleted() {
      this.Orders.updatePhoneCallCompleted(this.visit.id)
        .then(() => {
          console.log('call completed');
          this.callCompleted = 'Patient was called';
          this.showCallBox = true;
          this.visit.phone_call.phone_call_completed = 1;
        })
        .catch(err => {
          console.log(err);
        });
    }

    confirmOverrideSlvRequirement() {
      const config = {
        template: 'app/components/modals/confirm.tpl.html',
        data: {
          title: 'Override SLV Requirement',
          content: 'Are you sure you want to override SLV requirement?',
          buttons: { confirm: 'Yes', cancel: 'No' },
        },
      };

      this.ngDialog
        .openConfirm(config)
        .then(() => {
          this.completeTaskVideoCall();
        })
        .catch(() => {
          this.slv_task_approved = false;
        });
    }

    completeTaskVideoCall() {
      var task = this.Orders.current.getTask(this.Constants.VisitTasks.SmartLiveVideo);
      this.VideoService.completeTaskVideoCall(task);
    }
  }

  PrescribeController.$inject = [
    '$rootScope',
    '$interval',
    '$scope',
    '$timeout',
    '$log',
    '$window',
    'toastr',
    'Auth',
    'ngDialog',
    'Orders',
    'Pharmacy',
    'Notifications',
    'Utils',
    'Dosespot',
    'Constants',
    'MedicationService',
    'localStorageService',
    'VideoService',
    'Tracking',
    'Users',
    'Services',
    'ENV',
  ];
  angular.module('pims').component('visitPrescribe', {
    templateUrl: 'app/views/visits/detail/sections/prescribe/prescribe.html',
    controller: PrescribeController,
    bindings: {
      visit: '=',
      parent: '=',
      patient: '=',
    },
  });
})();
